/**
 * Strip HTML tags from a string and return plain text
 */
export const stripHtml = (str) => {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/<[^>]*>/g, '').trim();
};
